/**
 * ローカルタイムで今日の日付を YYYY-MM-DD 形式で取得
 * toISOString()はUTCなので、日本時間とずれる問題を回避
 */
export const getTodayDate = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};